import React from 'react'
import {FormikProps} from 'formik'

interface FormFieldErrorProps {
  name: string
  formik: FormikProps<any>
}

const FormFieldError: React.FC<FormFieldErrorProps> = ({name, formik}) => {
  const {touched, errors} = formik

  const isTouched = touched[name]
  const error = errors[name]

  // Only show error when touched and error is a string
  if (isTouched && typeof error === 'string') {
    return (
      <div className='fv-plugins-message-container'>
        <div className='fv-help-block'>
          <span role='alert'>{error}</span>
        </div>
      </div>
    )
  }

  // if (error && typeof error === 'string') {
  //   return (
  //     <div className='fv-plugins-message-container'>
  //       <div className='fv-help-block'>
  //         <span role='alert'>{error}</span>
  //       </div>
  //     </div>
  //   )
  // }

  return null
}

export default FormFieldError
